import { render, staticRenderFns } from "./prjeditor.vue?vue&type=template&id=96102896&"
import script from "./prjeditor.vue?vue&type=script&lang=js&"
export * from "./prjeditor.vue?vue&type=script&lang=js&"
import style0 from "./prjeditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96102896')) {
      api.createRecord('96102896', component.options)
    } else {
      api.reload('96102896', component.options)
    }
    module.hot.accept("./prjeditor.vue?vue&type=template&id=96102896&", function () {
      api.rerender('96102896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prjeditor.vue"
export default component.exports